import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { IActivityEntity } from '../../shared';

export class ActivityService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<IActivityEntity>(path, search, 'activities');
  }
}
